<template>
  <div class="">
    <div class="head-title">角色列表</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            添加管理员时角色的选择，可编辑角色名称、分配不同角色可以查看的相关功能，若不勾选则此子账户不显示该功能相关内容。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <div class="">
        <div class="tianjia">
          <nav class="navbar">
            <div class="nav-l">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="onSubmit = true"
                >添加角色</el-button
              >
            </div>
            <div class="nav-r">
              <el-input
                clearable
                v-model="czphone"
                style="width: 22.0rem; margin: 0 2.0rem 0 2.0rem"
                placeholder="请输入角色搜索"
                prefix-icon="el-icon-search"
                @change="onSubmiton"
              >
              </el-input>
              <el-button slot="append" type="primary" @click="onSubmiton"
                >搜索</el-button
              >
            </div>
          </nav>

          <el-table
            border
            :data="tableData.data"
            style="margin-top: 2.0rem"
            v-loading="tableLoading"
          >
            <el-table-column
              prop="role_name"
              label="角色列表"
              style="width: 20%"
              align="center"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              style="width: 20%"
              width="280"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  @click="(allocation = true), distribution(scope.row.id)"
                  type="primary"
                  size="mini"
                  >分配</el-button
                >
                <el-button
                  type="primary"
                  @click="
                    (dialogVisible = true),
                      bj(scope.row.id, scope.row.role_name)
                  "
                  size="mini"
                >
                  编辑
                </el-button>
                <el-button
                  type="danger"
                  @click="dele(scope.row.id)"
                  size="mini"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              :auto-scroll="false"
              @pagination="userTable"
            />
          </div>
        </div>
        <el-dialog title="添加角色" center :visible.sync="onSubmit" width="30%">
          <el-form ref="form" :model="AddAdministrator" label-width="10.0rem">
            <el-form-item label="角色名称:">
              <el-input
                clearable
                v-model="AddAdministrator.phone"
                placeholder="请输入角色名称"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="onSubmit = false">取 消</el-button>
            <el-button type="primary" @click="numoo()">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="修改角色" center :visible.sync="dialogVisible" width="30%">
          <el-form :model="modification" label-width="10.0rem">
            <el-form-item label="角色名称:">
              <el-input
                clearable
                v-model="modification.phone"
                placeholder="请输入角色名称"
              >
                {{ modification.phone }}
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="vak()">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="分配权限" center :visible.sync="allocation" width="30%">
          <el-tree
            :data="legeList"
            show-checkbox
            default-expand-all
            node-key="id"
            ref="tree"
            :default-checked-keys="duihao"
            highlight-current
            :props="defaultProps"
          ></el-tree>
          <span slot="footer" class="dialog-footer">
            <el-button @click="allocation = false">取 消</el-button>
            <el-button type="primary" @click="boxx()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import md5 from "js-md5";
import Pagination from "@/components/Pagination";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: {
        total: 0,
        data: [],
      }, //页面获取的数据 rout
      czphone: "", //筛选角色列表
      options: [
        {
          //筛选是否可用
          value: "1",
          label: "可用",
        },
        {
          value: "2",
          label: "禁用",
        },
      ],
      value: "", //筛选最终的id
      onSubmit: false, //添加管理员弹窗是否打开
      AddAdministrator: {
        //添加管理员账号密码用户
        phone: "",
      },
      rout_list: [], //添加管理员获取角色信息
      valu: "", //添加管理员角色value 值
      dialogVisible: false, //修改管理员
      valuer: "",
      modification: {
        phone: "",
        id: "",
      },
      allocation: false,
      legeList: [], //分配权限
      duihao: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      id: "",
      rules: {
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { min: 11, max: 30, message: "手机格式不正确", trigger: "blur" },
        ],
      },
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true,
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    //获取页面数据
    userTable() {
      this.axios
        .post(
          "/home/role/getSessionRoleList",
          qs.stringify({
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    //筛选
    onSubmiton() {
      this.axios
        .post(
          "/home/role/getSessionRoleList",
          qs.stringify({
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            role_name: this.czphone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    // 点击添加获取角色列表

    // 添加系统管理员
    numoo() {
      this.axios
        .post(
          "/home/role/addSessionRole",
          qs.stringify({
            role_name: this.AddAdministrator.phone,
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.AddAdministrator.phone=""
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
        })
        .catch(function (err) {});
    },
    //删除
    dele(e) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/home/role/delSessionRole",
              qs.stringify({
                id: e,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.userTable();
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    // 修改时获取到id和手机
    bj(e, l) {
      this.modification.phone = l;
      this.modification.id = e;
    },
    // 修改
    vak() {
      this.axios
        .post(
          "/home/role/editSessionRole",
          qs.stringify({
            role_name: this.modification.phone,
            id: this.modification.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 1) {
            this.dialogVisible = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.dialogVisible = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
        })
        .catch(function (err) {});
    },
    // 页数
    /*
    handleCurrentChange(val) {
      this.axios
        .post(
          "/home/role/getSessionRoleList",
          qs.stringify({
            account_id: this.tooken.id,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            page: val.page,
            number_page:val.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableData = res.data.data;
          this.userTable()
        })
        .catch(function (err) {});
    },*/
    // 获取权限
    distribution(e) {
      this.duihao = [];
      this.id = e;
      this.axios
        .post(
          "/home/role/getSessionPrivilegeList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.legeList = res.data.data;
        })
        .catch(function (err) {});
      this.axios
        .post(
          "/home/role/RolePrives",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            role_id: e,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.msg == "没有传递usertoken") {
            this.$router.push("/register");
          }
          let arr = [];
          res.data.data.forEach((item) => {
            if (item.children) {
              item.children.forEach((err) => {
                if (err.children) {
                  err.children.forEach((i) => {
                    arr.push(i.id);
                  });
                } else {
                  arr.push(err.id);
                }
              });
            } else {
              arr.push(item.id);
            }
          });
          this.duihao = arr;
        })
        .catch(function (err) {});
    },
    // 分配权限
    boxx() {
      let nodeList = Array.from(
        new Set([
          ...this.$refs.tree.getCheckedKeys(),
          ...this.$refs.tree.getHalfCheckedKeys(),
        ])
      );
      this.axios
        .post(
          "/home/role/sessionRolePrivilege",
          qs.stringify({
            role_id: this.id,
            pri_id: nodeList.toString(),
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.allocation = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.allocation = true;
            this.$message.error(res.data.msg);
          }
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}
.body_html {
  width: 100%;
  height: 100%;
}
.if_status {
  color: blue;
}
.tongg {
  color: red;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
}
.tianjia > main {
  font-size: 2.6rem;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
</style>

